// Formatage devise pour l'UI. Les montants backend sont en XOF entier.
// On les affiche en FCFA avec séparateur d'espace insécable (norme typo française).

const NBSP = " ";

/**
 * Montant SANS l'unité : "142 830".
 *
 * Utile quand l'UI compose elle-même le montant et la devise à des tailles
 * différentes (carte solde : chiffre en gros, "FCFA" en petit). Passer par
 * `formatXof` dans ce cas produisait "142 830 FCFA FCFA".
 */
export function formatXofAmount(amount: number | null | undefined): string {
  if (amount == null || Number.isNaN(amount)) return "—";
  const formatted = Math.abs(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  return `${amount < 0 ? "−" : ""}${formatted}`;
}

export function formatXof(amount: number | null | undefined): string {
  const amountOnly = formatXofAmount(amount);
  if (amountOnly === "—") return "—";
  return `${amountOnly}${NBSP}FCFA`;
}

// Helper de transition pour les écrans qui manipulent encore des cents
// (mocks UI non-critiques : Diaspora, VIP, validation/PriceDelta…).
// À supprimer dès que ces écrans seront branchés sur l'API.
export function formatFcfa(cents: number | null | undefined): string {
  if (cents == null || Number.isNaN(cents)) return "—";
  return formatXof(Math.round(cents / 100));
}
